import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"
import React, { forwardRef } from "react"

const alertVariants = cva(
  "relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        default: "bg-neutral-1 text-neutral-10 border-neutral-5",
        success: "bg-system-positive-1 text-neutral-10 border-system-positive-2/25 [&>svg]:text-system-positive-2",
        warning: "bg-system-warning-1 text-neutral-10 border-system-warning-2/25 [&>svg]:text-system-warning-2", 
        error: "bg-system-negative-1 text-neutral-10 border-system-negative-2/25 [&>svg]:text-system-negative-2",
        info: "bg-system-info-1 text-neutral-10 border-system-info-2/25 [&>svg]:text-system-info-2",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Alert = forwardRef(
  ({ className, variant, ...props }, ref) => (
    <div
      ref={ref}
      role="alert"
      className={cn(alertVariants({ variant }), className)}
      {...props}
    />
  )
)
Alert.displayName = "Alert"

const AlertDescription = forwardRef(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("text-sm [&_p]:leading-relaxed", className)}
      {...props}
    />
  )
)
AlertDescription.displayName = "AlertDescription"

export { Alert, AlertDescription }
